const messages = {
  widgetTitle: 'Get early access to new features',
  feedback: 'Feedback',
}

export default messages
